<template>
	<div>
		<div class="main">
			<div v-if="!isLoading">
				<div class="grid grid-cols-2 gap-x-4">
					<BaseInput ref="BaseInput" v-model="process.imdNetId" class="w-full" :label="$t('imd_connect')" type="text" disabled="disabled" />

					<BaseInput
						ref="BaseInput"
						v-model="process.damageAssessorReferenceNumber"
						class="w-full"
						:label="$t('damage_assessor_file_number')"
						type="text"
						v-if="process.damageAssessor"
						:disabled="!isDamageAssessorTransactionKeyEditable"
					/>

					<BaseInput
						ref="BaseInput"
						v-if="process.lawyerOffice"
						v-model="process.lawyerOfficeReferenceNumber"
						class="w-full"
						:label="$t('lawyers_office_file_number')"
						type="text"
						:disabled="!isLawyerOfficeTransactionKeyEditable"
					/>

					<BaseInput
						ref="BaseInput"
						v-model="process.repairShopReferenceNumber"
						class="w-full"
						:label="$t('general_file_number', { repairShopName: $store.getters.repairShopLabel })"
						type="text"
						:disabled="!isRepairShopTransactionKeyEditable"
					/>
				</div>
			</div>
			<LoadingSpinner v-else />
		</div>

		<div class="flex justify-end">
			<SaveButton :disabled="isLoading" @click="save" />
		</div>
	</div>
</template>

<script>
import { DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseInput from '@/components/forms/inputs/BaseInput';
import Authentication from '@/mixins/Authentication';
import SaveButton from '@/components/forms/buttons/SaveButton';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import { makeShadowCopy } from '@/plugins/Utils';

export default {
	name: 'TransactionKey',
	components: { LoadingSpinner, SaveButton, BaseInput },
	mixins: [Authentication],
	data() {
		return { process: {}, isLoading: true };
	},
	computed: {
		isNonSystemLawyer() {
			return this.process?.lawyerOffice?.isEditable;
		},
		isDamageAssessorTransactionKeyEditable() {
			if (this.isUserAllowedInLevel5or6 && this.$store.getters.isProcessComprehensive) {
				return this.process.damageAssessor === null || !this.process.damageAssessor.system_assessor;
			}
			return (
				this.isUserAllowedInLevel1 || this.isUserAllowedInLevel2 || (this.$store.getters.isProcessComprehensive && this.isUserAllowedInLevel5or6)
			);
		},
		isLawyerOfficeTransactionKeyEditable() {
			return (
				this.isUserAllowedInLevel1 ||
				this.isUserAllowedInLevel3 ||
				//(this.isNonSystemLawyer && (this.isUserAllowedInLevel2 || this.isUserAllowedInLevel5or6))
				(this.isNonSystemLawyer && this.isUserAllowedInLevel5or6)
			);
		},
		isRepairShopTransactionKeyEditable() {
			return this.isUserAllowedInLevel5or6 || this.isUserAllowedInLevel1;
		},
	},
	methods: {
		save() {
			this.isLoading = true;
			DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdPut(this.process.id, this.process)
				.then(response => {
					this.$store.dispatch('forceUpdateDamageCase');
					this.isLoading = false;
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('process_numbers_saved').toString(),
						icon: 'success',
					}).then(() => {
						this.$store.commit('setConfirmLeaving', false);
						this.$router.push({ name: 'management.process.edit', params: { processId: this.process.id, customer: this.process.customer.id } });
					});
				})
				.catch(error => {
					this.isLoading = false;
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
	},
	mounted() {
		this.isLoading = true;
		this.$store.dispatch('updateDamageCase', this.$route.params.processId).then(() => {
			this.process = makeShadowCopy(this.$store.getters.getDamageCase);
			this.isLoading = false;
		});
	},
};
</script>

<style scoped></style>
